"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var typeAdapters_1 = require("./typeAdapters");
var constants_1 = require("./constants");
var util_1 = require("./util");
var apple_pay_1 = require("./apple-pay");
var config_handler_1 = require("./config-handler");
var cardconnect = require("./tokenize/cardconnect");
var spreedly = require("./tokenize/spreedly");
var shared = require("./shared");
var uuid_1 = require("uuid");
var cloudflare_challenge_handler_1 = require("./cloudflare-challenge-handler");
var clientDefaults = {
    enableSandboxMode: false,
    overrideBaseUrl: undefined,
    enableDelay: false,
    secondsToDelay: 0
};
var iDonateClient = (function () {
    function iDonateClient(clientKey, options) {
        var _this = this;
        var _a;
        this.clientKey = clientKey;
        this.options = Object.assign({}, clientDefaults, options);
        this.allowTransaction = false;
        this.config = new config_handler_1.default(this.options);
        Object.assign(this, this.config);
        if (this.options.enableDelay && this.options.secondsToDelay) {
            var delay = this.options.secondsToDelay * 1000;
            setTimeout(function () {
                _this.allowTransaction = true;
            }, delay);
        }
        else {
            this.allowTransaction = true;
        }
        if (this.options.enableSandboxMode && console !== undefined) {
            console.info('[Sandbox] iDonate SDK Configuration:', JSON.parse(JSON.stringify(this)));
        }
        try {
            var _b = this.config, pcScriptBase = _b.pcScriptBase, pcScriptId = _b.pcScriptId;
            if (!pcScriptBase || !pcScriptId) {
                throw new Error('missing config');
            }
            var uuid = uuid_1.v4();
            var script_1 = window.document.createElement('script');
            script_1.setAttribute('src', pcScriptBase + '/' + uuid + '.js');
            script_1.setAttribute('id', pcScriptId);
            var appended_1 = false;
            var appendScript = function () {
                var _a;
                try {
                    if (appended_1)
                        return;
                    window.document.body.append(script_1);
                    appended_1 = true;
                }
                catch (e) {
                    (_a = console === null || console === void 0 ? void 0 : console.warn) === null || _a === void 0 ? void 0 : _a.call(console, 'not appended');
                }
            };
            appendScript();
            window.addEventListener('DOMContentLoaded', function () {
                window.document.body.append(script_1);
            });
        }
        catch (e) {
            (_a = console === null || console === void 0 ? void 0 : console.warn) === null || _a === void 0 ? void 0 : _a.call(console, 'Warning, partial initialization: ', String(e));
        }
        if (!this.currentOrganizationId) {
            this.setOrganizationId(this.clientKey);
        }
    }
    Object.defineProperty(iDonateClient.prototype, "organizationId", {
        get: function () {
            if (!this.currentOrganizationId) {
                throw new Error('organizationId undefined');
            }
            return this.currentOrganizationId;
        },
        enumerable: false,
        configurable: true
    });
    iDonateClient.prototype.createDonation = function (donation) {
        var _this = this;
        if (!this.allowTransaction) {
            throw new Error('Wow, that was fast - try again');
        }
        var payload = typeAdapters_1.buildCashPaymentPayload(this.organizationId, donation);
        var fetchCall = function (clearanceToken) { return fetch(_this.config.embedApiBaseUrl + "/donate/cash-payment", {
            method: 'POST',
            headers: __assign(__assign({}, constants_1.CLIENT_HEADERS), (clearanceToken ? { 'cf-validation-token': clearanceToken } : {})),
            body: JSON.stringify(payload),
            credentials: 'include',
        }); };
        return fetchCall()
            .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
            var clearance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(response.headers.get('cf-mitigated') === 'challenge')) return [3, 2];
                        return [4, cloudflare_challenge_handler_1.handleCFChallenge(response, this)];
                    case 1:
                        clearance = _a.sent();
                        return [2, fetchCall(clearance === null || clearance === void 0 ? void 0 : clearance.token)];
                    case 2: return [2, response];
                }
            });
        }); })
            .then(function (response) { return util_1.parseResponse(response, { throwErrors: true }); })
            .then(function (response) { return typeAdapters_1.buildDonationResult(response); });
    };
    iDonateClient.prototype.createTransaction = function (donation) {
        return this.createDonation(donation).then(function (result) {
            var _a;
            return {
                transactionId: (_a = result.transaction) === null || _a === void 0 ? void 0 : _a.id,
                _raw_response: result._raw_response,
            };
        });
    };
    iDonateClient.prototype.createPaymentMethod = function (paymentMethod) {
        return shared.createPaymentMethod(paymentMethod, this.config);
    };
    iDonateClient.prototype.tokenizeCardConnectBankAccountInternal = function (routingNumber, accountNumber) {
        return cardconnect.tokenizeBankAccount(routingNumber, accountNumber, this.config);
    };
    iDonateClient.prototype.setOrganizationId = function (organizationId) {
        this.currentOrganizationId = organizationId;
    };
    iDonateClient.prototype.tokenizeCardConnectBankAccount = function (account) {
        return this.tokenizeCardConnectBankAccountInternal(account.routingNumber, account.accountNumber).then(function (result) {
            if (!result.token || result.errorcode !== 0) {
                throw new types_1.ClientError(result.message, {
                    _rawPayload: result,
                });
            }
            return result.token;
        });
    };
    iDonateClient.prototype.tokenizeSpreedlyCreditCard = function (data) {
        return spreedly.tokenizeCreditCard(data, this.config);
    };
    iDonateClient.prototype.tokenizeSpreedlyBankAccount = function (data) {
        return spreedly.tokenizeBankAccount(data, this.config);
    };
    iDonateClient.prototype.tokenizeSpreedlyPayPal = function (data) {
        return spreedly.tokenizePayPal(data, this.config);
    };
    iDonateClient.prototype.generateCardConnectTokenizerUrl = function (formOptions) {
        var formDefaults = {
            enhancedresponse: 'true',
            useexpiry: 'true',
            usecvv: 'true',
            placeholderyear: '2020',
            invalidinputevent: 'true',
            placeholder: 'Card Number',
            placeholdercvv: 'CVV',
            formatinput: 'true',
            expirymonthtitle: 'Month',
            unique: 'true',
            css: constants_1.CARD_CONNECT_DEFAULT_STYLE,
        };
        var resolvedOptions = __assign(__assign({}, formDefaults), (formOptions || {}));
        var paramString = new URLSearchParams(resolvedOptions)
            .toString()
            .replace('+', '%20');
        return this.config.cardConnectTokenizerUrl + "?" + paramString;
    };
    iDonateClient.prototype.waitForDonationResult = function (donationId) {
        var _this = this;
        function isReady(response) {
            return !!response.processed && !!response.transaction;
        }
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                var pollHandle;
                pollHandle = setInterval(function () {
                    fetch(_this.config.embedApiBaseUrl + "/donate/cash-payment/" + donationId + "/payment_status", {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    })
                        .then(function (response) { return response.json(); })
                        .then(function (rawResponse) { return rawResponse.result; })
                        .then(function (response) {
                        if (isReady(response)) {
                            if (pollHandle) {
                                clearInterval(pollHandle);
                                pollHandle = null;
                            }
                            if (response.error) {
                                reject(new types_1.ClientError(response.error));
                            }
                            resolve(typeAdapters_1.buildDonationResult({
                                _raw_response: __assign({ campaign: null, designation: {}, donor: {}, form_data: {}, id: null, schedule: {}, transaction: {} }, response),
                            }));
                        }
                        else {
                        }
                    });
                }, 2000);
            }, 2000);
        });
    };
    iDonateClient.prototype.tokenizeCardConnectApplePay = function (applePayRequest) {
        var _this = this;
        var applePay = new apple_pay_1.default(applePayRequest);
        var merchantSessionId = '';
        var promiseStart = applePay.begin();
        return new Promise(function (resolve, reject) {
            promiseStart
                .then(function (session) {
                session.onvalidatemerchant = function (event) {
                    var validationPayload = {
                        apple_pay_url: _this.config.applePayUrl,
                        organization_id: _this.organizationId,
                    };
                    applePay
                        .createSession(validationPayload, _this.config.embedApiBaseUrl)
                        .then(function (merchantSession) {
                        merchantSessionId =
                            merchantSession.result.merchantSessionIdentifier;
                        session.completeMerchantValidation(merchantSession.result);
                    });
                };
                session.onpaymentauthorized = function (event) {
                    applePay
                        .tokenizeWithCardConnect(event.payment, _this.config.cardConnectBaseUrl)
                        .then(function (data) {
                        var _a, _b;
                        var unifiedContact = __assign(__assign({}, event.payment.billingContact), { email: (_a = event.payment.shippingContact) === null || _a === void 0 ? void 0 : _a.emailAddress, phone: (_b = event.payment.shippingContact) === null || _b === void 0 ? void 0 : _b.phoneNumber });
                        var result = {
                            applePaySession: session,
                            cardConnectResponse: data,
                            billingContact: unifiedContact,
                            merchantSessionId: merchantSessionId,
                        };
                        resolve(result);
                    });
                };
            })
                .catch(function (err) { return reject(err); });
        });
    };
    return iDonateClient;
}());
exports.default = iDonateClient;
